<script setup lang="ts">
import { useStorage } from '#imports';

const { formatedImageUrl } = useStorage();

const { creator } = defineProps({
  creator: {
    type: Object,
    required: true
  }
});
</script>
<template>
  <div class="wrapper creator-card" :style="`background-image: url('${formatedImageUrl(creator.profile_image_url, 600, 600, 80)}')`">
    <NuxtLinkLocale
      :to="`/@${creator.mappr_handle}`"
    >
      <div class="creator-info">
        <div>
          <small class="creator-handle">
            @{{ creator.mappr_handle }}
          </small>
          <p class="creator-name">
            {{ creator.display_name }}
          </p>
          <p class="creator-summary">
            {{ creator.summary }}
          </p>
          <span v-if="creator.maps_count[0] !== 0" class="creator-maps">
            {{ creator.maps_count[0].count }} {{ creator.maps_count[0].count === 1 ? 'Map' : 'Maps' }}
          </span>
        </div>
      </div>
    </NuxtLinkLocale>
  </div>
</template>
<style scoped lang="postcss">
@import '@/assets/css/typography.pcss';
@import "@/assets/css/shadows.pcss";
.wrapper {
  position: relative;
  min-height: 20rem;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.creator-card {
  height: 100%;
  padding: 1.25rem 1rem 1.75rem;
  color: white;
  display: flex;
  align-items: end;
}

.creator-info {
  min-height: 100%;
  min-width: 100%;

  .creator-handle {
    padding: 0;
    color: var(--color-rose-500);
    @mixin typeface-small;
    font-weight: 400;
  }

  .creator-name {
    margin: 0.25rem 0 0.25rem 0;
    padding: 0;
    @mixin typeface-summary;
    font-weight: 500;
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .creator-summary {
    margin: 0;
    padding: 0;
    @mixin typeface-regular;
    /* Guarantee single line */
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 1.25rem;
    font-weight: 300;
  }

  .creator-maps {
    @mixin typeface-regular;
    border-radius: 1rem;
    padding: 0.25rem 1rem;
    border: 1px solid;
    border-color: var(--color-slate-200)
  }
}

.creator-info::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(200deg, rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 1));
  border-radius: 0.5rem;
}
</style>
